import { Detector, debuggerChecker } from 'devtools-detector';

const detector = new Detector({ checkers: [debuggerChecker] });
const view = document.createElement('div');

document.body.appendChild(view);

detector.addListener(
  isOpen =>
    (view.innerText = isOpen
      ? 'devtools status: open'
      : 'devtools status: close')
);
// process.env.NODE_ENV !== development
if ( process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'testing') {
  detector.lanuch();
}



// WEBPACK FOOTER //
// ./src/util/detector.js